import {Component, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {ModalDirective} from "ngx-bootstrap/modal";
import {ChatMessageService} from "../../message.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NotificationService} from "inet-core";
import {MessageContact} from "../../model/MessageContact";
import {SearchInputComponent} from "../search-input/search-input.component";
import {GroupCallListComponent} from "../group-call-list/group-call-list.component";

declare let iNet: any;

@Component({
  selector: 'message-group',
  templateUrl: './message-group.component.html',
  styleUrls: ['./message-group.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MessageGroupComponent implements OnInit {
  groupChatForm!: FormGroup;
  @ViewChild('childModal') childModal!: ModalDirective;
  @ViewChild(SearchInputComponent) searchInput!: SearchInputComponent;
  @ViewChild(GroupCallListComponent) groupCallList!: GroupCallListComponent;
  @Output() roomSelected = new EventEmitter<any>();
  @Output() closeMessageGroup = new EventEmitter<any>();
  listMember: MessageContact[] = [];
  arrMemberGroup: MessageContact[] = [];
  arrMemberBeforeEdit: MessageContact[] = [];
  checkTitleToEdit = false;
  checkSearch = false;
  checkSelected = false;
  nameGroup: any;
  lastPage: boolean = false;
  creator: any;

  constructor(
    private messageService: ChatMessageService,
    private fb: FormBuilder,
    private notificationService: NotificationService,
  ) {
    this.getListMember();
    this.getDataToEdit();
  }

  ngOnInit() {
    this.initGroupChatForm();
  }

  getDataToEdit() {
    this.messageService.onCallToEditMessageForm().subscribe(data => {
      this.creator = data.messageForm.creator;
      this.searchContacts('')
      this.groupChatForm.patchValue(data.messageForm);
      this.checkTitleToEdit = true;

      // const arrMemberOfGroup = Object.assign([], data.messageForm.members || []);
      // let quantityArrMemberOfGroup = 0;
      // const arrMemberOfGroupCopy = Object.assign([], arrMemberOfGroup || []);
      // for (let i = 0; i < this.listMember.length; i++) {
      //   arrMemberOfGroup.forEach((item: any) => {
      //     if (this.listMember[i] && this.listMember[i].usercode === item.username) {
      //       this.listMember.splice(i, 1);
      //       arrMemberOfGroupCopy.splice(arrMemberOfGroupCopy.indexOf(item), 1);
      //       quantityArrMemberOfGroup++;
      //     }
      //   });
      //   if (quantityArrMemberOfGroup >= arrMemberOfGroup.length) {
      //     break;
      //   }
      // }
      // // this.showChildModal();
      // this.arrMemberGroup = [];
      // this.childModal.show();

      function addMemberToArray(arrayList: MessageContact[], arrayResult: MessageContact[], arrayBefore: MessageContact[], arrayFlag: [], creatorGroup: any) {
        arrayList.forEach((itemList: any) => {
          arrayFlag.forEach((item: any) => {
            if (itemList && itemList.usercode === item.username) {
              arrayResult.unshift(itemList)
            }
          });
        })
        arrayResult.forEach((item: any) => {
          if (item.usercode === creatorGroup) {
            arrayResult.splice(arrayResult.indexOf(item), 1)
          }
        })
        // arrayBefore = arrayResult.map((item: any) => item);
        arrayResult.forEach((item: any) => {
          arrayBefore.push(item)
        })
      }

      if (this.arrMemberGroup.length === 0 && this.arrMemberBeforeEdit.length === 0) {
        addMemberToArray(this.listMember, this.arrMemberGroup, this.arrMemberBeforeEdit, data.messageForm.members, data.messageForm.creator);
      } else {
        this.arrMemberGroup.splice(0, this.arrMemberGroup.length);
        this.arrMemberBeforeEdit.splice(0, this.arrMemberBeforeEdit.length);
        addMemberToArray(this.listMember, this.arrMemberGroup, this.arrMemberBeforeEdit, data.messageForm.members, data.messageForm.creator);
      }
      this.childModal.show();
    });
  }

  private initGroupChatForm() {
    this.groupChatForm = this.fb.group({
      subject: ['', Validators.required],
      members: [''],
      conferenceID: ['']
    });
  }

  get subject() {
    return this.groupChatForm.get('subject');
  }

  get members() {
    return this.groupChatForm.get('members');
  }

  get conferenceID() {
    return this.groupChatForm.get('conferenceID');
  }

  getListMember() {
    this.messageService.loadFriends().subscribe(data => {
      this.listMember = this.removeCreatorCreateGroup(data || []);
    });
  }

  showModalAndResetListMember() {
    this.getListMember();
    this.resetGroupChatForm();
    this.searchInput.clear();
    this.childModal.show();
  }

  hideChildModal() {
    this.childModal.hide();
    this.searchInput.clear();
  }

  addUserCodeToGroup(member: any) {
    if (member) {
      if (!this.arrMemberGroup.includes(member, 0)) {
        this.arrMemberGroup.unshift(member);
      } else {
        this.removeMemberFormGroup(member);
      }
    }
  }

  removeMemberFormGroup(member: any) {
    this.arrMemberGroup.splice(this.arrMemberGroup.indexOf(member), 1);
  }

  changeArrMemberToString() {
    // console.log('this.member', this.members)
    if (this.arrMemberBeforeEdit.length === 0) {
      if (this.members) {
        this.members.patchValue(stringSubmit(this.arrMemberGroup).join(','))
      }
    } else {
      if (this.members) {
        this.members.patchValue(stringSubmit(arraySubmit(this.arrMemberGroup, this.arrMemberBeforeEdit)).join(','))
      }
    }

    function stringSubmit(arrayInput: any[]) {
      const arrayResult: any[] = []
      arrayInput.forEach((item: any) => {
        arrayResult.push(item.usercode);
      });
      return arrayResult;
    }

    function arraySubmit(arrayInput1: any[], arrayInput2: any[]) {
      const arrayTemp: any[] = [];
      for (let i = 0; i < arrayInput1.length; i++) {
        for (let j = 0; j < arrayInput2.length; j++) {
          if (arrayInput1[i] === arrayInput2[j]) {
            arrayTemp.push(arrayInput1[i]);
          }
        }
      }
      for (let i = 0; i < arrayInput1.length; i++) {
        for (let j = 0; j < arrayTemp.length; j++) {
          if (arrayInput1[i] === arrayTemp[j]) {
            arrayInput1.splice(i, 1)
          }
        }
      }
      for (let i = 0; i < arrayInput2.length; i++) {
        for (let j = 0; j < arrayTemp.length; j++) {
          if (arrayInput2[i] === arrayTemp[j]) {
            arrayInput2.splice(i, 1)
          }
        }
      }
      return [...arrayInput1, ...arrayInput2];
    }
  }

  selectRoom(roomName: string | null) {
    this.roomSelected.emit(roomName);
  }

  submitForm() {
    this.changeArrMemberToString();
    if (this.conferenceID && this.conferenceID.value == '') {
      this.saveGroupMessageForm();
    } else {
      this.editGroupMessageForm();
    }
    this.hideChildModal();
  }

  saveGroupMessageForm() {
    this.groupChatForm.get('subject')?.setValue(this.nameGroup.trim());
    if (this.groupChatForm.valid) {
      const saveForm = this.fb.group({
        subject: ['', Validators.required],
        members: ['', Validators.required],
      });
      saveForm.patchValue(this.groupChatForm.value);
      // console.log('saveForm.getRawValue()', saveForm.getRawValue())
      this.messageService.saveGroupMessageForm(saveForm.getRawValue()).subscribe(data => {
        this.notificationService.showMessage('Thêm mới nhóm \"' + data.subject + '\" thành công', 'success', 'Add Group Call');
        this.messageService.reloadGroupList();
        this.selectRoom(data);
        this.resetGroupChatForm();
      });
    }
  }

  editGroupMessageForm() {
    if (this.groupChatForm.valid) {
      // console.log('this.groupChatForm.getRawValue()', this.groupChatForm.getRawValue())
      this.messageService.saveGroupMessageForm(this.groupChatForm.getRawValue()).subscribe(data => {
        this.notificationService.showMessage('Chỉnh sửa \"' + data.subject + '\" nhóm thành công', 'success', 'Edit Group Call');
        this.messageService.reloadGroupList();
        this.hideChildModal();
        this.selectRoom(data);
        this.resetGroupChatForm();
      });
    }
  }

  resetGroupChatForm() {
    this.initGroupChatForm();
    this.arrMemberGroup = [];
    this.checkTitleToEdit = false;
    this.hideChildModal();
    this.nameGroup = '';
  }

  searchContacts(value: string = '') {
    value = value.toLowerCase().trim();
    // if (value === this._keyword) {
    //   return;
    // }
    // this._keyword = value;
    this.messageService.searchContacts(value, (contacts: any) => {
      this.listMember = this.removeCreatorSearch(this.removeCreatorCreateGroup(contacts || []));
    });
  }

  removeCreatorSearch(data: any) {
    if (data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].usercode === this.creator) {
          data.splice(i, 1);
        }
      }
      return data;
    }
  }

  removeCreatorCreateGroup(data: any) {
    if (data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].usercode === iNet.username) {
          data.splice(i, 1);
        }
      }
      return data;
    }
  }


  // searchContact() {
  //   // value = value.toLowerCase().trim();
  //   // if (value === this._keyword) {
  //   //   return;
  //   // }
  //   // this._keyword = value;
  //   let arrayResult: any[] = [];
  //   let arrayResult1: any[] = [];
  //   let arrayResult2: any[] = [];
  //   this.messageService.loadFriends().subscribe(data => {
  //     console.log('tt', data)
  //     data = this.removeCreator(data);
  //     data.forEach((itemList: any) => {
  //       // console.log('ggg', itemList.fullname.toLowerCase())
  //       if (itemList.fullname.toLowerCase().search(this.keyword) >= 0) {
  //         arrayResult1.push(itemList);
  //       }
  //       if (itemList.usercode.slice(0, itemList.usercode.indexOf('@')).search(this.keyword) >= 0) {
  //         arrayResult2.push(itemList);
  //       }
  //     })
  //     arrayResult = arrayResult1.concat(arrayResult2);
  //     // console.log('result total', arrayResult)
  //     arrayResult = [...new Set(arrayResult)];
  //     console.log('test', [...new Set(arrayResult)]);
  //     // arrayResult  = arrayResult.filter((item, index) => arrayResult.indexOf(item) !== index);
  //     // console.log('result1', arrayResult1)
  //     // console.log('result2', arrayResult2)
  //     console.log('result', arrayResult)
  //   })
  // }
}
